import React, { forwardRef, useEffect, useState } from "react";
import { Chip } from "./chip";
import { StyledChipGroup } from "./chip.styles";
import { ChipGroupProps } from "./chip.types";

export const Group = forwardRef<HTMLDivElement, ChipGroupProps>(
    ({ onChange, options, multiple = true, ...rest }, ref) => {
        const [groupValue, setGroupValue] = useState<string[]>([]);
        const groupOnChange = (e, { value, selected }) => {
            let groupValueCopy;
            if (selected) {
                groupValueCopy = multiple ? [...groupValue, value] : [value];
            } else {
                groupValueCopy = groupValue.filter((item) => item !== value);
            }
            setGroupValue(groupValueCopy);
            onChange?.(e, groupValueCopy);
        };

        useEffect(() => {
            let groupValueCopy: string[] = [];
            options.forEach(({ value, selected }) => {
                if (selected === true) {
                    groupValueCopy = multiple
                        ? [...groupValueCopy, value]
                        : [value];
                }
            });
            setGroupValue(groupValueCopy);
        }, []);

        return (
            <StyledChipGroup ref={ref} {...rest}>
                {options.map(({ value, label, ...rest }) => (
                    //Note: optimize rerendering of sibling chips
                    <Chip
                        key={value}
                        onClick={(e, selected) =>
                            groupOnChange(e, { value, selected })
                        }
                        {...rest}
                        selected={groupValue.includes(value)}
                    >
                        {label}
                    </Chip>
                ))}
            </StyledChipGroup>
        );
    }
);

Group.displayName = "ChipGroup";
